import { render, staticRenderFns } from "./product-zoomer-ailem.vue?vue&type=template&id=2325cb00&scoped=true&"
import script from "./product-zoomer-ailem.vue?vue&type=script&lang=js&"
export * from "./product-zoomer-ailem.vue?vue&type=script&lang=js&"
import style0 from "./product-zoomer-ailem.vue?vue&type=style&index=0&id=2325cb00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2325cb00",
  null
  
)

export default component.exports